

const styles = css`
  :host {
    align-items: center;
    display: inline-flex;
    height: 20px;
    justify-content: center;
    width: 20px;
  }
  svg {
    height: 100%;
    width: 100%;
  }
`;

export class IconStrideMark extends HTMLElement {
  static argonHydrate(element) {
    if (!(element instanceof IconStrideMark)) return;
    if (element.isConnected && !element.#bindingsMounted) {
      element.#syncHydratedProps();
      element.connectedCallback();
    }
    if (element.#root) element.#wireEvents(element.#root);
  }
  static observedAttributes = [];

  
  
  #root;
  #bindingsMounted = false;
  #hydrating = false;
  #isCSR = false;



  #syncHydratedProps() {
    if (this.#isCSR) return;

  }

  constructor(props) {
    super();
    if (props !== undefined) {
      this.#isCSR = true;

      this.#initState();
      const shadow = this.attachShadow({ mode: 'open' });
      shadow.innerHTML = this.#render();
      this.#mount(shadow, false);
    }
  }

  connectedCallback() {
    if (this.#isCSR || this.#bindingsMounted) return;
    this.#syncHydratedProps();
    this.#initState();
    const shadow = this.shadowRoot;
    const root = shadow ?? this.attachShadow({ mode: 'open' });
    if (!shadow) root.innerHTML = this.#render();
    this.#mount(root, !!shadow);
  }


  #initState() {

  }

  #render() {
    
    return `<style>${this.#escText(styles)}</style><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M7.65 4H21l-3.42 4.34H9.43L7.86 10.3l3.05 2.06h6.47c2.3 0 3.62 2.62 2.2 4.43L17.06 20H3l3.42-4.34h8.71l1.25-1.58-3.05-2.06H6.72c-2.26 0-3.58-2.54-2.24-4.36L7.65 4Z"></path></svg>`;
  }



  #mount(root, hydrating) {
    this.#root = root;
    this.#bindingsMounted = true;
    this.#hydrating = hydrating;
    this.#updateBindings();
    this.#hydrating = false;
    this.#wireEvents(root);
    if (!root.__argonEventObserver) {
      const observer = new window.MutationObserver(() => this.#wireEvents(root));
      observer.observe(root, { childList: true, subtree: true });
      Object.defineProperty(root, '__argonEventObserver', { value: observer });
    }
    this.setAttribute('hydrated', '');
    setTimeout(() => { if (this.#root === root) this.#wireEvents(root); }, 0);
  }

  #replaceRange(start, end, value) {
    if (!start || !end) return;
    const html = String(value);
    const sole = start.nextSibling;
    if (sole && sole !== end && sole.nextSibling === end && sole.nodeType === 3 && !/[<&]/.test(html)) {
      if (html.startsWith(sole.data)) sole.appendData(html.slice(sole.data.length));
      else sole.data = html;
      return;
    }
    const template = document.createElement('template');
    template.innerHTML = html;
    if (sole && sole !== end && sole.nextSibling === end && template.content.childNodes.length === 1 && this.#patchElement(sole, template.content.firstChild)) return;
    let oldNode = start.nextSibling;
    let newNode = template.content.firstChild;
    while (newNode) {
      const nextNew = newNode.nextSibling;
      if (!oldNode || oldNode === end) {
        end.before(newNode);
        if (newNode.nodeType === 1 || newNode.nodeType === 11) this.#wireEvents(newNode);
      } else {
        const nextOld = oldNode.nextSibling;
        if (!this.#patchNode(oldNode, newNode)) {
          oldNode.before(newNode);
          oldNode.remove();
          if (newNode.nodeType === 1 || newNode.nodeType === 11) this.#wireEvents(newNode);
        }
        oldNode = nextOld;
      }
      newNode = nextNew;
    }
    while (oldNode && oldNode !== end) {
      const nextOld = oldNode.nextSibling;
      oldNode.remove();
      oldNode = nextOld;
    }
  }

  #patchElement(oldEl, newEl) {
    if (!oldEl || !newEl || oldEl.nodeType !== 1 || newEl.nodeType !== 1 || oldEl.localName !== newEl.localName) return false;
    for (const attr of [...oldEl.attributes]) {
      if (attr.name !== 'hydrated' && !newEl.hasAttribute(attr.name)) oldEl.removeAttribute(attr.name);
    }
    for (const attr of [...newEl.attributes]) {
      if (oldEl.getAttribute(attr.name) !== attr.value) oldEl.setAttribute(attr.name, attr.value);
    }
    this.#patchChildren(oldEl, newEl);
    this.#wireEvents(oldEl);
    return true;
  }

  #patchNode(oldNode, newNode) {
    if (!oldNode || !newNode) return false;
    if (oldNode.nodeType === 3 && newNode.nodeType === 3) {
      if (oldNode.data !== newNode.data) oldNode.data = newNode.data;
      return true;
    }
    if (oldNode.nodeType === 8 && newNode.nodeType === 8) {
      if (oldNode.nodeValue !== newNode.nodeValue) oldNode.nodeValue = newNode.nodeValue;
      return true;
    }
    return this.#patchElement(oldNode, newNode);
  }

  #patchChildren(oldEl, newEl) {
    let oldNode = oldEl.firstChild;
    let newNode = newEl.firstChild;
    while (newNode) {
      const nextNew = newNode.nextSibling;
      if (!oldNode) {
        oldEl.append(newNode);
        if (newNode.nodeType === 1 || newNode.nodeType === 11) this.#wireEvents(newNode);
      } else {
        const nextOld = oldNode.nextSibling;
        if (!this.#patchNode(oldNode, newNode)) {
          oldEl.insertBefore(newNode, oldNode);
          oldNode.remove();
          if (newNode.nodeType === 1 || newNode.nodeType === 11) this.#wireEvents(newNode);
        }
        oldNode = nextOld;
      }
      newNode = nextNew;
    }
    while (oldNode) {
      const nextOld = oldNode.nextSibling;
      oldNode.remove();
      oldNode = nextOld;
    }
  }
  #escText(v) {
    return String(v).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }


  #updateBindings(prop) {
    if (!this.#bindingsMounted) return;
    

  }

  #wireEvents(scope) {
    const root = this.#root;

    const roots = [scope];
    for (let index = 0; index < roots.length; index++) {
      const candidates = roots[index].nodeType === 1 ? [roots[index], ...roots[index].querySelectorAll('*')] : [...roots[index].querySelectorAll('*')];
      for (const element of candidates) {
        customElements.upgrade(element);
        const hydrate = () => {
          customElements.upgrade(element);
          const definition = customElements.get(element.localName);
          definition?.argonHydrate?.(element);
        };
        if (element.isConnected && customElements.get(element.localName)) hydrate();
        else if (element.localName.includes('-')) customElements.whenDefined(element.localName).then(hydrate);
        else queueMicrotask(hydrate);
        if (element.shadowRoot) roots.push(element.shadowRoot);
      }
    }
  }
}
